import React, { useState, useEffect } from "react";
import { FormValidate } from "../../../../../components/formValidate";
import CustomButton from "../../../../../components/inputs/button";
import DatePickerField from "../../../../../components/inputs/datepicker";
import TextField from "../../../../../components/inputs/textfield";
import Snackbar from "../../../../../components/snackbar/snackbar";
import Loader from "../../../../../components/loader/loader";
import {
  admin_advertisement_add,
  admin_advertisement_list,
  admin_advertisement_update,
  advertisement_approve_status,
  advertisement_revert_status,
} from "../../../admin.api";
import "./dialog.css";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";

let required = [
  "start_date",
  "end_date",
  "title",
  "advertisement",
  "file_name",
  "fee",
  "transaction_details",
];

const tomorrow = new Date();
tomorrow.setDate(tomorrow.getDate());
const today = new Date();
today.setDate(today.getDate());

const Dialog = (props) => {
  const {
    adminType,
    open,
    formData: propFormData,
    edit,
    selectedParam,
    approveStatus,
    view,
  } = props;

  const [formData, setFormData] = useState(propFormData || {});
  const [formErrors, setFormErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const adParams = useParams();

  // Update state when props change
  useEffect(() => {
    setFormData(propFormData || {});
  }, [propFormData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: null }));
  };

  const handleTransChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: null }));
  };
  const fetchEventDetails = () => {
    setIsActive(true);
    admin_advertisement_list().then((res) => {
      let tdata = res.filter((item) => item.id == adParams.id);
      let newData = {
        ...tdata[0],
        start_date: moment(tdata[0].start_date).format("DD-MM-YYYY"),
        end_date: moment(tdata[0].end_date).format("DD-MM-YYYY"),
      };
      setFormData(newData);
      setIsActive(false);
    });
  };

  useEffect(() => {
    fetchEventDetails();
  }, []);

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) handleClose();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const fileType = file.name.split(".").pop().toLowerCase();
    if (["jpg", "jpeg", "png"].includes(fileType)) {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (readerEvent) => {
        const image = new Image();
        image.src = readerEvent.target.result;

        image.onload = () => {
          const height = image.height;
          const width = image.width;
          if (width === 1200 && height === 750) {
            setFormData((prev) => ({
              ...prev,
              file_name: file.name,
              advertisement: file,
            }));
          } else {
            setSnackMessage("Incorrect image dimensions. Required: 1200x750 px");
            setIsSnackError(true);
            setSnackOpen(true);
            setIsActive(false);
          }
        };
      };
    } else {
      setSnackMessage("File should be in .jpg / .jpeg / .png format");
      setIsSnackError(true);
      setSnackOpen(true);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const error = FormValidate(formData, required);

    if (Object.keys(error).length === 0) {
      setIsActive(true);
      const formDataToSend = new FormData();

      const formatDate = (date) => {
        if (!date) return "";
        if (typeof date === "string") return date;
        return new Date(date).toISOString().slice(0, 10);
      };

      Object.keys(formData).forEach((key) => {
        let value = formData[key];
        if (key === "start_date" || key === "end_date") {
          value = formatDate(value);
        }
        if (key === "advertisement") {
          if (typeof value !== "string" && value instanceof File) {
            formDataToSend.append(key, value);
          }
        } else if (key === "file_name") {
          formDataToSend.append(key, formData?.file_name);
        } else {
          formDataToSend.append(key, value ?? "");
        }
      });

      const apiCall = admin_advertisement_update(formData.id, formDataToSend);

      apiCall
        .then((res) => {
          setSubmitted(true);
          setIsActive(false);
          setSnackMessage(res.message);
          setIsSnackError(false);
          setSnackOpen(true);
          setFormErrors({});
        })
        .catch((error) => {
          setSubmitted(false);
          setIsActive(false);
          let errorMessage = error.message;
          let validationErrors = {};
          if (error.response && error.response.data && error.response.data.errors) {
            const errors = error.response.data.errors;
            // Map validation errors to state
            Object.keys(errors).forEach((key) => {
              if (errors[key] && errors[key][0]) {
                validationErrors[key] = errors[key][0];
              }
            });
            // Get first error message for Snackbar
            const firstErrorKey = Object.keys(errors)[0];
            if (firstErrorKey && errors[firstErrorKey] && errors[firstErrorKey][0]) {
              errorMessage = errors[firstErrorKey][0];
            }
          }
          setFormErrors(validationErrors);
          setSnackMessage(errorMessage);
          setIsSnackError(true);
          setSnackOpen(true);
        });
    } else {
      setSubmitted(false);
      setFormErrors(error);
      setSnackMessage("Please fill all mandatory fields");
      setIsSnackError(true);
      setSnackOpen(true);
    }
  };

  const handleDatePickerChange = (e, name) => {
    let date = e.value;
    setFormData((prev) => ({
      ...prev,
      [name]: date || null,
    }));
    setFormErrors((prev) => ({
      ...prev,
      [name]: null,
    }));
  };

  const saMessage = (status) => {
    Swal.fire({
      title: "Message",
      input: "textarea",
      inputLabel: "Provide a reason",
      showCancelButton: true,
      confirmButtonColor: "#0A223D",
      confirmButtonText: "Submit",
      cancelButtonText: "Cancel",
      inputAttributes: {
        "aria-label": "Type your message here",
      },
      inputValidator: (value) => {
        if (!value.trim()) return "Please describe the reason";
      },
    }).then((message) => {
      if (message.isConfirmed && message.value.trim()) {
        let rpdetails = formData?.id;
        if (!rpdetails) {
          setSnackMessage("Error: Advertisement ID is missing.");
          setIsSnackError(true);
          setSnackOpen(true);
          return;
        }

        let rdata = {
          status: status,
          rp_id: rpdetails,
          revert_reason: message.value,
        };

        if (adminType === 1) {
          rdata[status === 1 ? "admin_message" : "user_message"] =
            message.value;
        } else {
          rdata["super_admin_message"] = message.value;
        }

        setIsActive(true);
        advertisement_revert_status(rpdetails, rdata)
          .then((res) => {
            setSnackMessage(res?.message || "Action successful");
            setIsSnackError(false);
            setSnackOpen(true);
          })
          .catch((error) => {
            setSnackMessage(
              error.response?.data?.message || "Error processing request"
            );
            setIsSnackError(true);
            setSnackOpen(true);
          })
          .finally(() => {
            setIsActive(false);
          });
      }
    });
  };

  const handleApproveStatus = (status) => {
    let data = { status: status };
    setIsActive(true);
    advertisement_approve_status(selectedParam, data)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };
  const handleClose = () => {
    props?.history.push("/advertisement-list");
  };
  return (
    <>
      <Loader open={isActive} />
      <div className="view-container ">
        <div className="">
          <Snackbar
            style={{ height: "100%" }}
            message={snackMessage}
            error={isSnackError}
            open={snackOpen}
            close={snackbarClose}
          />
          <div className="row">
            <div className="flexDisplay">
              <div className="diaTitleCon">
                Edit Advertisement
                <hr />
              </div>
              <div className="dia-close" onClick={handleClose}>
                <div className="diaCloseCon">
                  <div className="diaClose">&#10005;</div>
                </div>
              </div>
            </div>
            <form action="">
              <div className="row book-form">
                <div className="col-12">
                  <TextField
                    label="Title"
                    disabled={view}
                    onChange={handleChange}
                    value={formData.title ?? ""}
                    name="title"
                    required
                    error={!!formErrors.title}
                  />
                  {formErrors.title && (
                    <span className="text-danger small">{formErrors.title}</span>
                  )}
                </div>

                <div className="col-12">
                  <TextField
                    type="file"
                    label="Advertisement [height:750px, width:1200px, .jpg/.jpeg/.png]"
                    onChange={handleFileChange}
                    disabled={view}
                    fileName={formData.file_name}
                    accept=".jpg,.jpeg,.png"
                    required
                    error={!!formErrors.advertisement || !!formErrors.file_name}
                  />
                  {(formErrors.advertisement || formErrors.file_name) && (
                    <span className="text-danger small">
                      {formErrors.advertisement || formErrors.file_name}
                    </span>
                  )}
                </div>

                <div className="col-12 not-required">
                  <DatePickerField
                    value={formData.start_date ?? null}
                    // minDate={today}
                    label="Start Date"
                    required
                    disabled={view}
                    error={!!formErrors.start_date}
                    onChange={(e) => handleDatePickerChange(e, "start_date")}
                  />
                  {formErrors.start_date && (
                    <span className="text-danger small">{formErrors.start_date}</span>
                  )}
                </div>

                <div className="col-12 not-required">
                  <DatePickerField
                    value={formData.end_date ?? null}
                    // minDate={tomorrow}
                    label="End Date"
                    required
                    disabled={view}
                    error={!!formErrors.end_date}
                    onChange={(e) => handleDatePickerChange(e, "end_date")}
                  />
                  {formErrors.end_date && (
                    <span className="text-danger small">{formErrors.end_date}</span>
                  )}
                </div>

                <div className="col-12">
                  <TextField
                    label="Fee"
                    disabled={view}
                    onChange={handleChange}
                    value={formData.fee ?? ""}
                    name="fee"
                    required
                    error={!!formErrors.fee}
                  />
                  {formErrors.fee && (
                    <span className="text-danger small">{formErrors.fee}</span>
                  )}
                </div>

                <div className="col-12">
                  <TextField
                    label="Transaction Details"
                    disabled={view}
                    onChange={handleTransChange}
                    value={formData.transaction_details ?? ""}
                    name="transaction_details"
                    required
                    multiline
                    error={!!formErrors.transaction_details}
                  />
                  {formErrors.transaction_details && (
                    <span className="text-danger small">{formErrors.transaction_details}</span>
                  )}
                </div>

                {view &&
                  formData.revert_reason !== null &&
                  formData?.status === 2 && (
                    <div className="col-12 ad-revert d-flex align-items-center">
                      <label className="col-3">
                        <b>Revert Reason</b>
                      </label>
                      <div className="m-0">:</div>
                      <div className="col-6 p-2 m-0">
                        {formData?.revert_reason}
                      </div>
                    </div>
                  )}

                {!view && (
                  <div className="col-12">
                    <CustomButton
                      label={"Submit"}
                      disabled={submitted}
                      onClick={handleSubmit}
                    />
                  </div>
                )}

                {view && adminType === 2 && approveStatus === 0 && (
                  <div className="d-flex justify-content-center mt-4">
                    <button
                      type="button"
                      className="btn btn-approve btn-success mr-2"
                      onClick={() => handleApproveStatus(1)}
                    >
                      Approve
                    </button>
                    <button
                      type="button"
                      className="btn btn-reject btn-danger"
                      onClick={() => saMessage(5)}
                    >
                      Revert with Reason
                    </button>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dialog;
